import React from 'react';

import { Form, Input } from 'antd';
import { FormattedMessage } from 'react-intl';

const { Item } = Form;

const ModalForm = ({ form, views }) => {
  const { getFieldDecorator } = form;
  const formLableConfig = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6, offset: 2 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
  };
  return (
    <Form id="apiToken">
      <Item
        {...formLableConfig}
        label={<FormattedMessage id="page.ApiToken.tokenName" />}
      >
        {
          getFieldDecorator('name', {
            initialValue:`${views}`,
            rules: [
              {
                required: true,
                message: <FormattedMessage id="global.errors.required" />
              },
              {
                max: 20,
                message: <FormattedMessage id="page.ApiToken.tokenLength" />
              }
            ],
          })(<Input />)
        }
      </Item>
    </Form>
  );
};


export default Form.create()(ModalForm);


// WEBPACK FOOTER //
// ./src/views/Setup/ApiToken/components/ModalForm.js